import { unsafeCSS } from "lit";

export const type = (value: "lg" | "sm" | "md") => unsafeCSS(`:host([type="${value}"])`);

export const cssLayout = (value: "desktop" | "mobile") => unsafeCSS(`:host([layout="${value}"])`);
